const createDefaultApolloPlugin = app => ({
  requestDidStart() {
    return {
      didEncounterErrors: requestContext => {
        if (!requestContext) return;
        app.events.emit('monitor:log', {
          ...requestContext,
          clear: true
        });
      }
    };
  }
});

module.exports = createDefaultApolloPlugin;
